<template>
    <div class="box patrolInfo">
        <div class="box-head bg-color1 flex-algin">
            <el-page-header @back="goBack" :content="secondTitle" style="color:#AECFDC;width:300px;"></el-page-header>
            <p class="color2" style="flex:1;text-align: left;">{{info.checkItem}}</p>
            <!-- <p class="color3" style="width:180px;text-align: right;">更多统计<i class="el-icon-arrow-right" style="margin-left:10px;"></i></p> -->
        </div>
        <div class="box-table">
            <!-- <div class="con-item color4">
                <p>项目选择：</p>
                <el-select v-model="opt.projectId" placeholder="请选择" class="tqmInfo-val">
                    <el-option
                    v-for="item in projects"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="con-item-area bg-color5 color7">
                <div>
                    <p>事项：</p>
                    <div v-if="info.isRedItem=='0'" style="background:rgba(253, 212, 212, 0.1);width:100%;height:220px;overflow: auto;">
                        <div style="width:100%;display:flex;" v-for="item in info.redLineList" :key="item.id">
                            <p style="width:150px;">{{item.typeNumber}}、{{item.typeItem}}</p>
                            <p style="flex:1;">{{item.redClause}}</p>
                            <p style="width:200px;">引发后果：{{item.consequence}}</p>
                            <p style="width:200px;">责任岗位：{{item.resPosition}}</p>
                        </div>
                    </div>
                    <div v-else-if="info.isRedItem=='1'" style="background:rgba(253, 212, 212, 0.1);width:100%;height:220px;overflow: auto;">
                        <div style="width:100%;display:flex;" v-for="(item,index) in info.keyPositionList" :key="item.id">
                            <p style="width:240px;">{{index+1}}、{{item.typeItem}}</p>
                            <p style="flex:1;">考勤标准：{{item.redClause}}%，当前考勤率{{item.consequence}}%</p>
                            <p style="width:200px;">姓名：{{item.resPosition}}</p>
                            <p style="width:320px;">责任岗位：{{item.workType}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <p>处理结果：</p>
                    <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="请输入内容"
                        v-model="opt.disposeResult">
                    </el-input>
                </div>
                <div>
                    <p>
                        <span style="display: inline-block;width:100px;">限定日期</span>
                        <el-date-picker
                            v-model="opt.rectifyAchieveTime"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </p>
                    <p class="flex-algin">
                        <span style="display: inline-block;width:100px;">处罚</span>
                        <el-input placeholder="" v-model="opt.punish" style="background: rgba(112, 112, 112, 0.3);width: 180px;"></el-input>
                    </p>
                    <p class="flex-algin">
                        <span style="display: inline-block;width:100px;">附件</span>
                        <img src="../../assets/image/upload.png" @click="addFile" style="width:32px;height:24px;" />
                    </p>
                    <p class="flex-algin">
                        <span style="display: inline-block;width:100px;">曝光公告</span>
                        <el-checkbox v-model="isExposure"></el-checkbox>
                    </p>
                    <p class="flex-algin" style="justify-content: center;">
                        <!-- <el-button type="warning" class="bg-color3 color4">不达标</el-button> -->
                        <el-button type="primary" @click="saveFun">提交</el-button>
                    </p>
                </div>
            </div>
            <div class="con-item color4 flex-wrap">
                <p class="color5" style="width:100%;">已处理事项</p>
                <hr style="width:100%;color:#707070;background:#707070;">
                <div style="width:100%;">
                    <div class="list-item bg-color5 color2" v-for="item in matters" :key="item.id">
                        <div style="width:20%;position: relative;">
                            <p class="nowrap flex-algin" style="width:100%;" title="">整改督办人：{{item.checkPerson}}</p>
                            <p class="flex-algin">整改完成时间：{{item.updateDate}}</p>
                        </div>
                        <div style="flex:1;display:flex;">
                            <p style="width:150px;display: inline-block;">整改内容：</p>
                            <div v-if="item.isRedItem=='0'" style="background:rgba(253, 212, 212, 0.1);width:100%;height:100px;overflow: auto;">
                                <div style="width:100%;display:flex;" v-for="item in info.redLineList" :key="item.id">
                                    <p style="width:150px;">{{item.typeNumber}}、{{item.typeItem}}</p>
                                    <p style="flex:1;">{{item.redClause}}</p>
                                    <p style="width:200px;">引发后果：{{item.consequence}}</p>
                                    <p style="width:200px;">责任岗位：{{item.resPosition}}</p>
                                </div>
                            </div>
                            <div v-else-if="item.isRedItem=='1'" style="background:rgba(253, 212, 212, 0.1);width:100%;height:100px;overflow: auto;">
                                <div style="width:100%;display:flex;" v-for="(item,index) in info.keyPositionList" :key="item.id">
                                    <p style="width:240px;">{{index+1}}、{{item.typeItem}}</p>
                                    <p style="flex:1;">考勤标准：{{item.redClause}}%，当前考勤率{{item.consequence}}%</p>
                                    <p style="width:160px;">姓名：{{item.resPosition}}</p>
                                    <p style="width:270px;">责任岗位：{{item.workType}}</p>
                                </div>
                            </div>
                        </div>
                        <div style="display:flex;width:20%;padding-left:30px;">
                            <p style="width:150px;display: inline-block;">处理结果：</p>
                            <p class="color6" style="height:100px;flex:1;display: flex;align-items: center;">{{item.disposeResult}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="上传附件"
            :visible.sync="dialogVisible"
            width="600px">
            <div style="flex:1;display:flex;flex-wrap: wrap;" class="item-con">
                <div style="width:100px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="item in fileList" :key="item.url">
                    <!-- <p class="title nowrap" style="width:100%;" :title="child.attachmentName">{{child.attachmentName}}</p> -->
                    <p  style="width:100%;">
                        <img v-if="item.fileType=='1'" style="width:50px;height:50px;" src="../../assets/image/office/word.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='2'" style="width:50px;height:50px;" src="../../assets/image/office/excel.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='3'" style="width:50px;height:50px;" src="../../assets/image/office/pdf.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='4'" style="width:50px;height:50px;" src="../../assets/image/office/photo.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='5'" style="width:50px;height:50px;" src="../../assets/image/office/undefined.png" @click="showFile(item.url)" />
                    </p>
                    <p  style="width:100%;">{{item.name}}</p>
                    <!-- <p class="name" style="width:100%;">{{child.userName}}上传</p>
                    <p class="time" style="width:100%;">{{child.createDate}}</p> -->
                </div>
                <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                    <el-upload
                        class="upload-demo"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data={type:213}
                        :show-file-list="false"
                        :on-success="fileSuccess">
                        <el-button size="small" class="primary">点击上传</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util';
import myHttp from '../../untils/port';
import base from '../../untils/base';
export default {
    data(){
        return{
            secondTitle:'',
            projects:[],
            opt:{
                id:'',
                rectifyAchieveTime:'',
                punish:'',
                punishFile:'',
                disposeResult:'',
                isExposure:true,
                personName:'',
                personId:'',
            },
            // isExposure:true,
            matters:[],//历史验收事项列表
            id:'',
            dialogVisible:false,
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            fileList:[],//上传文件列表
            isExposure:undefined,
            info:{},
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId');
        this.id = this.$route.params.id
        this.getData()
    },
    methods:{
        //获取项目
        getData(){
            var that = this;
            // myHttp.getProjectById({
            //     id: this.groupId
            // }).then(function(resp) {
            //     if (resp.data.code == '200') {
            //         var project = resp.data.data.project;
            //         that.secondTitle = project.name
            //     } else {
            //         that.$message.error(resp.data.msg)
            //     }
            //     },
            //     function() {}
            // )
            myHttp.findSupervisionById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.resultMap.qsManagerSupervision
                    that.info = data
                    console.log(data)
                    that.secondTitle = data.projectName
                    that.matters = resp.data.data.resultMap.qsManagerSupervisionList||[]
                }
            })
        },
        goBack(){
            this.$router.go(-1)
            //window.history.back()
        },
        //提交信息
        saveFun(){
            var that = this
            if(this.isExposure){
                this.opt.isExposure = 0
            }else{
                this.opt.isExposure = 1
            }
            this.opt.id = this.id
            for(var i=0;i<this.fileList.length;i++){
                if(this.opt.punishFile==''){
                    this.opt.punishFile = this.fileList[i].url
                }else{
                    this.opt.punishFile += ','+this.fileList[i].url
                }
            }
            this.opt.personName = util.session.get('user').name
            this.opt.personId = util.session.get('user').id
            myHttp.saveSupervision(this.opt).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('提交成功')
                    that.$router.push({ path: '/patrol' })
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //获取已处理事项
        getDataList(){
            var that = this

        },
        //添加上传图片
        addFile(){
            this.dialogVisible = true
        },
        //监听上传成功
        fileSuccess(res,file,opt,index){
            if(res.code==200){
                var obj = {}
                obj.url = res.data.saveUrls
                obj.fileType = this.getImg(obj.url)
                var name = file.name.split('.')
                name.pop()
                obj.name = name.join();
                this.fileList.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width: 100%;
        position: relative;
        height: 100%;
        background: #fff;
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
        font-size: 18px;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 40px );
        position: relative;
        padding: 20px;
        box-sizing: border-box;
        font-size: 18px;
    }
    .el-table .box-head-title{
        font-size: 16px;
    }
    .con-item{
        display: flex;
        justify-content: left;
        align-items: center;
        margin-bottom: 15px;
    }
    .con-item-area{
        width: 100%;
        display: flex;
        padding: 10px 10px 20px;
        font-size: 18px;
        margin-bottom: 20px;
    }
    .con-item p,.con-item-area p{
        padding: 10px 15px 10px 15px;
        text-align: left;
    }
    .con-item-area>div:nth-child(1){
        width: calc( 100% - 600px );
        padding: 0 20px 0 20px;
    }
    .con-item-area>div:nth-child(2){
        width: 300px;
        padding: 0 20px 0 20px;
    }
    .con-item-area>div:nth-child(3){
        width: 300px;
        padding: 0 20px 0 20px;
    }
    .patrolInfo .list-item{
        display: flex;
        height: 120px;
        width: 100%;
    }
    

    .flex-wrap{
        display:flex;
        flex-wrap: wrap;
    }
    .flex-algin{
        display: flex;
        align-content: center;
        align-items: center;
    }
    .felx-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .patrolInfo .bg-color1{
        background: #0D2DFF;
    }
    .patrolInfo .bg-color2{
        background: #0D2DFF;
    }
    .patrolInfo .bg-color3{
        background: #FFBC01;
    }
    .patrolInfo .bg-color4{
        background: #36C635;
    }
    .patrolInfo .bg-color5{
        background: #F5F5F5;
    }
    .patrolInfo .color1{
        color: #17B2FE;
    }
    .patrolInfo .color2,.patrolInfo .color2 span{
        color: #fff;
    }
    .patrolInfo .color3{
        color: #4C9AFF;
    }
    .patrolInfo .color4{
        color: #fff;
    }
    .patrolInfo .color5{
        color: #36C635;
    }
    .patrolInfo .color6{
        color: #CEFF00;
    }
      .patrolInfo .color7{
        color: #6b6b6b;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    p{
        margin: 0;
    }
</style>
<style>
    .patrolInfo .el-page-header__content{
      color: #fff;
    }
    .el-input__inner{
        background: transparent;
        border: 0;
    }
    .patrolInfo .el-textarea__inner{
        color: inherit;
        background: rgba(253, 212, 212, 0.1);
        border: 0;
        color: #4D7BF4;
    }
    .patrolInfo .color4 span,.patrolInfo .el-input__inner{
        color: #fff;
    }
    .patrolInfo .el-input__inner{
        background: transparent;
        border: 0;
        color:#4C9AFF;
    }
    .patrolInfo .el-page-header__content{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width:180px;
    }
</style>